import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=24c5b49c&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=24c5b49c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5b49c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c5b49c')) {
      api.createRecord('24c5b49c', component.options)
    } else {
      api.reload('24c5b49c', component.options)
    }
    module.hot.accept("./HomePage.vue?vue&type=template&id=24c5b49c&scoped=true", function () {
      api.rerender('24c5b49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/HomePage.vue"
export default component.exports